import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SESSION_STORAGE_KEY } from "../utils/analyics/analyticsConstant";

const usePageVisitCounter = () => {
  const location = useLocation();

  useEffect(() => {
    const count =
      Number(sessionStorage.getItem(SESSION_STORAGE_KEY.PAGE_VISIT_COUNT) || 0) + 1;

    sessionStorage.setItem(SESSION_STORAGE_KEY.PAGE_VISIT_COUNT, String(count));
  }, [location.pathname]);
};

export default usePageVisitCounter;
